import { Subscription } from "../types/auth";

/**
 * Whether a subscription gives Greenback Pro. The one rule the web gates on,
 * and the same as mobile's `computeIsPro`: a comp or open_signup window
 * (`grandfathered_until`), an active or retrying subscription, or a cancelled
 * one whose paid period has not ended.
 *
 * No subscription at all reads as Pro: the backend has not answered yet, and
 * the paywall must not flash at a subscriber while it does.
 */
export const computeIsPro = (subscription?: Subscription, now: Date = new Date()): boolean => {
  if (!subscription) return true;
  if (subscription.grandfathered_until && new Date(subscription.grandfathered_until) > now) return true;
  if (subscription.status === "active") return true;
  if (subscription.status === "grace_period") return true;
  if (subscription.status === "cancelled" && subscription.expires_at && new Date(subscription.expires_at) > now) return true;
  return false;
};
